export class PriceBoxUpdateArgument {
  descriptiveIdentifier: string;
  calculationId: string;
  bannerText: string;
  value: string;

  constructor(descriptiveIdentifier: string, calculationId: string, bannerText: string, value: string) {

    this.descriptiveIdentifier = descriptiveIdentifier;
    this.calculationId = calculationId;
    this.bannerText = bannerText;
    this.value = value;
  }
}
